export default __webpack_public_path__ + "static/ai-consultancy-1--mobile-37dd65208796cee5b6469b29e0349ca2.webp";